module.exports = "<div style=\"width: 100%; height: 100%;\">\n  <img style=\"width: 100%; height: 100%;\" [src]=\"data.imageSrc\">\n</div>"